// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetFormFieldResponse = App.Http.Responses.FormField.GetFormFieldResponse;
import GetFormFieldsResponse = App.Http.Responses.FormField.GetFormFieldsResponse;
import GetFormFieldsRequest = App.Http.Requests.FormField.GetFormFieldsRequest;
import BatchStoreFormFieldRequest = App.Http.Requests.FormField.BatchStoreFormFieldRequest;
import BatchUpdateFormFieldRequest = App.Http.Requests.FormField.BatchUpdateFormFieldRequest;
import BatchInsertUpdateFormFieldResponse = App.Http.Responses.FormField.BatchInsertUpdateFormFieldResponse;
import BaseBatchDeleteRequest = App.Http.Requests.BaseBatchDeleteRequest;
import StoreFormFieldRequest = App.Http.Requests.FormField.StoreFormFieldRequest;
import UpdateFormFieldRequest = App.Http.Requests.FormField.UpdateFormFieldRequest;
import GetFormFieldUsagesResponse = App.Http.Responses.FormField.GetFormFieldUsagesResponse;

class FormFieldApi extends TenantBaseApi {
    /**
     * Get list of form fields
     *
     * - Request: GetFormFieldsRequest
     * - Response: GetFormFieldsResponse
     */
    async index(request: GetFormFieldsRequest): Promise<GetFormFieldsResponse> {
        return await this.get<GetFormFieldsResponse, GetFormFieldsRequest>("/form-fields", {
            params: request,
        });
    }

    /**
     * Get specific form field
     *
     * - Request: none
     * - Response: GetFormFieldResponse
     */
    async show(formFieldId: string, request?: unknown): Promise<GetFormFieldResponse> {
        return await this.get<GetFormFieldResponse, unknown>(`/form-fields/${formFieldId}`, {
            params: request,
        });
    }

    /**
     * Get form structures that use a reusable local field
     */
    async usages(formFieldId: string): Promise<GetFormFieldUsagesResponse> {
        return await this.get<GetFormFieldUsagesResponse, never>(`/form-fields/${formFieldId}/usages`);
    }

    /**
     * Store a form field
     */
    async store(request: StoreFormFieldRequest): Promise<GetFormFieldResponse> {
        return await this.post<GetFormFieldResponse, StoreFormFieldRequest>("/form-fields", request);
    }

    /**
     * Update a form field
     */
    async update(formFieldId: string, request: UpdateFormFieldRequest): Promise<GetFormFieldResponse> {
        return await this.put<GetFormFieldResponse, UpdateFormFieldRequest>(`/form-fields/${formFieldId}`, request);
    }

    /**
     * Delete a form field
     */
    async destroy(formFieldId: string): Promise<void> {
        return await this.delete<void>(`/form-fields/${formFieldId}`);
    }

    /**
     * Batch insert form fields
     *
     * - Request: BatchStoreFormFieldRequest
     * - Response: BatchInsertUpdateFormFieldResponse
     */
    async batchInsert(request: BatchStoreFormFieldRequest): Promise<BatchInsertUpdateFormFieldResponse> {
        return await this.post<BatchInsertUpdateFormFieldResponse, BatchStoreFormFieldRequest>(
            "/form-fields/batch",
            request
        );
    }

    /**
     * Batch update form fields
     *
     * - Request: BatchUpdateFormFieldRequest
     * - Response: BatchInsertUpdateFormFieldResponse
     */
    async batchUpdate(request: BatchUpdateFormFieldRequest): Promise<BatchInsertUpdateFormFieldResponse> {
        return await this.patch<BatchInsertUpdateFormFieldResponse, BatchUpdateFormFieldRequest>(
            "/form-fields/batch",
            request
        );
    }

    /**
     * Batch delete form fields
     *
     * - Request: BaseBatchDeleteRequest
     * - Response: null
     */
    async batchDelete(request: BaseBatchDeleteRequest): Promise<void> {
        return await this.delete<void, BaseBatchDeleteRequest>("/form-fields/batch", { data: request });
    }
}

export const formFieldApi = new FormFieldApi();
